import { render, staticRenderFns } from "./BusSetDialog.vue?vue&type=template&id=15ef32ba&"
import script from "./BusSetDialog.vue?vue&type=script&lang=js&"
export * from "./BusSetDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports